import { VejledningAfsnit } from './VejledningAfsnit'; 
export class Vejledning {
        public afsnit: VejledningAfsnit[];
        public type: string;
        public opgavepakkenavn: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Vejledning.ts